module.exports = __webpack_public_path__ + "img/fake-popup-PC-2.569b52a1.png";